const OSS_IMAGE_BASE_URL = 'https://minio.yogeeai.com/yogee/images'

/**
 * Build a fully-qualified OSS image URL from the given relative path.
 * @param {string} relativePath - Path relative to assets/images directory.
 * @returns {string} Absolute URL that points to the image stored in OSS.
 */
export const getOssImageUrl = (relativePath = '') => {
    const normalizedPath = String(relativePath || '').replace(/^\/+/, '')
    if (!normalizedPath) {
        return OSS_IMAGE_BASE_URL
    }
    return `${OSS_IMAGE_BASE_URL}/${normalizedPath}`
}

export const IMAGE_CONFIG = {
    ossBaseUrl: OSS_IMAGE_BASE_URL,
    buildUrl: getOssImageUrl
}

export default {
    ...IMAGE_CONFIG
}
